import React from 'react';
import './filter.css'
const Filter = () => {
    return(
        <div>
            <div className="south-search-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="advanced-search-form">
                                <div className="search-title">
                                    <p>Search for your home</p>
                                </div>
                                <form action="#" method="post" id="advanceSearch">
                                    <div className="row">

                                        <div className="col-12 col-md-4 col-lg-3">
                                            <div className="form-group">
                                                <input type="input" className="form-control" name="input"
                                                       placeholder="Keyword"/>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-lg-3">
                                            <div className="form-group">
                                                <select className="form-control" id="cities">
                                                    <option>All Cities</option>
                                                    <option>Riga</option>
                                                    <option>Melbourne</option>
                                                    <option>Vienna</option>
                                                    <option>Vancouver</option>
                                                    <option>Toronto</option>
                                                    <option>Calgary</option>
                                                    <option>Adelaide</option>
                                                    <option>Perth</option>
                                                    <option>Auckland</option>
                                                    <option>Helsinki</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-lg-3">
                                            <div className="form-group">
                                                <select className="form-control" id="catagories">
                                                    <option>All Catagories</option>
                                                    <option>Apartment</option>
                                                    <option>Bar</option>
                                                    <option>Farm</option>
                                                    <option>House</option>
                                                    <option>Store</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-lg-3">
                                            <div className="form-group">
                                                <select className="form-control" id="offers">
                                                    <option>All Offers</option>
                                                    <option>100% OFF</option>
                                                    <option>75% OFF</option>
                                                    <option>50% OFF</option>
                                                    <option>25% OFF</option>
                                                    <option>10% OFF</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-xl-3">
                                            <div className="form-group">
                                                <select className="form-control" id="listings">
                                                    <option>All Listings</option>
                                                    <option>Listings 1</option>
                                                    <option>Listings 2</option>
                                                    <option>Listings 3</option>
                                                    <option>Listings 4</option>
                                                    <option>Listings 5</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-xl-2">
                                            <div className="form-group">
                                                <select className="form-control" id="bedrooms">
                                                    <option>Bedrooms</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5+</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4 col-xl-2">
                                            <div className="form-group">
                                                <select className="form-control" id="bathrooms">
                                                    <option>Bathrooms</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5+</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-8 col-lg-12 col-xl-5 d-flex">
                                            <div className="slider-range">
                                                <div data-min="120" data-max="820" data-unit=" sq. ft"
                                                     className="slider-range-price ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"
                                                     data-value-min="120" data-value-max="820">
                                                    <div
                                                        className="ui-slider-range ui-widget-header ui-corner-all"></div>
                                                    <span className="ui-slider-handle ui-state-default ui-corner-all"
                                                          tabIndex="0"></span>
                                                    <span className="ui-slider-handle ui-state-default ui-corner-all"
                                                          tabIndex="0"></span>
                                                </div>
                                                <div className="range">120 sq. ft - 820 sq. ft</div>
                                            </div>

                                            <div className="slider-range">
                                                <div data-min="10" data-max="1300" data-unit=" mil"
                                                     className="slider-range-price ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"
                                                     data-value-min="10" data-value-max="1300">
                                                    <div
                                                        className="ui-slider-range ui-widget-header ui-corner-all"></div>
                                                    <span className="ui-slider-handle ui-state-default ui-corner-all"
                                                          tabIndex="0"></span>
                                                    <span className="ui-slider-handle ui-state-default ui-corner-all"
                                                          tabIndex="0"></span>
                                                </div>
                                                <div className="range">10 mil - 1300 mil</div>
                                            </div>
                                        </div>

                                        <div className="col-12 search-form-second-steps">
                                            <div className="row">

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <select className="form-control" id="types">
                                                            <option>All Types</option>
                                                            <option>Apartment <span>(30)</span></option>
                                                            <option>Land <span>(69)</span></option>
                                                            <option>Villas <span>(103)</span></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <select className="form-control" id="catagories2">
                                                            <option>All Catagories</option>
                                                            <option>Apartment</option>
                                                            <option>Bar</option>
                                                            <option>Farm</option>
                                                            <option>House</option>
                                                            <option>Store</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <select className="form-control" id="Actions">
                                                            <option>All Actions</option>
                                                            <option>Sales</option>
                                                            <option>Booking</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <select className="form-control" id="city2">
                                                            <option>All City</option>
                                                            <option>City 1</option>
                                                            <option>City 2</option>
                                                            <option>City 3</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="form-group">
                                                        <select className="form-control" id="Actions3">
                                                            <option>All Actions</option>
                                                            <option>Sales</option>
                                                            <option>Booking</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="form-group">
                                                        <select className="form-control" id="city3">
                                                            <option>All City</option>
                                                            <option>City 1</option>
                                                            <option>City 2</option>
                                                            <option>City 3</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <div className="form-group">
                                                        <select className="form-control" id="city5">
                                                            <option>All City</option>
                                                            <option>City 1</option>
                                                            <option>City 2</option>
                                                            <option>City 3</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 d-flex justify-content-between align-items-end">
                                            <div className="more-filter">
                                                <a href="#" id="moreFilter">+ More filters</a>
                                            </div>
                                            <div className="form-group mb-0">
                                                <button type="submit" className="btn south-btn">Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Filter;